import Index from "../_components/Home/Index";

const Home = () => {
  return <Index />;
};

export default Home;
